import { Badge, IconButton, Tooltip } from '@mui/material';
import { type FC } from 'react';

import { ButtonWrapper } from '../ButtonWrapper';
import { IconLabel } from '../IconLabel';
import { useInjection } from 'inversify-react';
import { type SavingStateController } from '@/engine/app/SavingState.controller';
import { TYPES } from '@/engine/ioc';
import { type UserPermissions } from '@/engine/app/models/CaseState';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { observer } from 'mobx-react';

export const SavingButton: FC<{
  userPermissions: UserPermissions;
  isCineloopActive: boolean;
  saveCase: () => Promise<void>;
}> = observer(({ userPermissions, isCineloopActive, saveCase }) => {
  const savingStateController = useInjection<SavingStateController>(TYPES.SavingStateController);

  const isChanged = savingStateController.isChanged;
  const isSavingDisabled = !userPermissions.canSaveCase || !isChanged || isCineloopActive;
  const saveButtonToolTip = !userPermissions.canSaveCase
    ? 'You have no permissions to save this plan'
    : !isChanged
      ? 'There are no changes to save'
      : isCineloopActive
        ? 'Saving is not allowed during cineloop'
        : '';
  return (
    <Badge color="primary" overlap="circular" badgeContent="!" invisible={isSavingDisabled} sx={badgeStyles}>
      <ButtonWrapper disabled={isSavingDisabled}>
        <Tooltip title={saveButtonToolTip} placement="bottom">
          <div>
            <IconButton
              data-testid={'SaveCaseBtn'}
              size="small"
              onClick={(): void => {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                saveCase();
              }}
              disabled={isSavingDisabled}
            >
              <CloudUploadOutlinedIcon color="secondary" fontSize="medium" />
            </IconButton>
          </div>
        </Tooltip>
        <IconLabel>Save</IconLabel>
      </ButtonWrapper>
    </Badge>
  );
});

const badgeStyles = { '& .MuiBadge-badge': { fontSize: '0.6em', margin: 0.25, height: 15, minWidth: 15 } };
